import { IKnmListState } from '../interfaces/IKnmListState';

export const initialKnmListState: IKnmListState = {
  planId: undefined,
  data: [],
  findData: [],
  order: null,
  page: 0,
  pageCount: 0,
  totalCount: 0,
  searchValue: '',
  rejected: 0,
};
